module.exports = __webpack_public_path__ + "img/art_1.3c03cc70.png";